<template>
  <el-dialog
    title="ユーザー情報の編集"
    :visible.sync="isOpenEditModal"
    width="30%"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :before-close="onCloseModal"
  >
    <el-form
      ref="editForm"
      :model="user"
      label-width="30%"
      :rules="rules"
      label-position="top"
      @submit.prevent.native="onSubmit"
    >
      <div>
        <ErrorMessage :messages="errorMessages" @close="errorMessages = null" :is-array="true"/>
      </div>
      <el-form-item label="ユーザー名" prop="full_name">
        <el-input name="full_name" v-model="user.full_name" />
      </el-form-item>
      <el-form-item label="ユーザーのメールアドレス" prop="email">
        <el-input name="email" v-model="user.email" disabled />
      </el-form-item>
      <el-form-item label="利用できる機能" prop="menu_ids" class="menu-list">
        <div v-for="(item, index) in user.menu_ids" :key="index" class="item-data">
          <el-checkbox v-model="user.menu_ids[index].checked" :label="true" @change="handleChange(index)">
            {{ item.title }}
          </el-checkbox>
          <el-radio-group v-if="user.menu_ids[index].checked" v-model="user.menu_ids[index].action" class="ml-4">
            <el-radio :label="READ" size="large">一般ユーザー </el-radio>
            <el-radio :label="ALL" size="large">アドミン</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
      <el-form-item label="パスワード" prop="password">
        <el-input name="password" type="password" v-model="user.password" />
      </el-form-item>
      <!-- <el-form-item label="Organization" prop="org_id">
        <el-select name="org_id" v-model="user.org_id" class="w-full">
          <el-option
              v-for="org in organizations"
              :key="org.id"
              :label="org.name"
              :value="org.id">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="Activate" prop="is_active">
        <el-switch
            v-model="user.is_active"
            active-color="#13ce66"
            inactive-color="#ff4949">
        </el-switch>
      </el-form-item> -->
      <div class="text-right">
        <el-button @click="onCloseModal">キャンセル</el-button>
        <el-button native-type="submit" class="btn-main" :disabled="isLoading">
          <i v-if="isLoading" class="el-icon-loading"></i>
          更新
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import {READ, ALL} from "@/const/batch";
import { validEmail } from "@/utils/validate";
import { mapActions, mapState } from "vuex";
import ErrorMessage from "@/components/ErrorMessage";
import _ from "lodash";
import EngineApi from "@/api/engine.api";

export default {
  name: "EditUser",
  components: { ErrorMessage },
  data() {
    return {
      user: {
        id: null,
        email: null,
        password: null,
        full_name: null,
        menu_ids: [],
        org_id: null
      },
      userDetail: {},
      dataMenu: [],
      rules: {
        full_name: [
          {
            required: true,
            trigger: "blur",
            message: 'ユーザー名を入力してください。'
          },
          { max: 100, trigger: "blur", message: '100 文字以下にしてください。' },
        ],
        menu_ids: [
          {
            required: true,
            type: 'array',
            trigger: "change",
            message: '利用できる機能を選んでください。'
          },
          {
            validator: (rule, value, callback) => {
              if (value.length < 1) {
                callback(new Error("利用できる機能を選んでください。"));
              } else {
                let index = 0;
                value.forEach((item) => {
                  if (item.checked) {
                    index += 1;
                  }
                })
                if (!index) {
                  callback(new Error("利用できる機能を選んでください。"));
                }
                callback();
              }
            },
            trigger: "change",
          },
        ],
        password: [
          {
            min: 8,
            max: 20,
            trigger: 'blur',
            message: 'パスワードの長さは8~20文字を入力してください。'
          }
        ],
        email: [
          {
            required: true,
            trigger: "blur",
            message: 'ユーザーのメールアドレスを入力してください。',
          },
          {
            validator: (rule, value, callback) => {
              if (!validEmail(value)) {
                callback(new Error("有効なメールアドレスを入力してください。"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          { max: 100, trigger: "blur", message: '100 文字以下にしてください。' },
        ],
      },
      isLoading: false,
      errorMessages: null,
      errorMenu: null,
      READ,
      ALL
    };
  },
  props: {
    isOpenEditModal: {
      default: false,
    },
    propUserDetail: {
      default: null,
    },
    orgId: {
      required: true
    }
  },
  computed: {
    ...mapState({
      organizations: (state) => state.admin_organizations.organizations,
      userState: (state) => state.admin_user.user,
      authUser: (state) => state.auth.authUser,
    }),
  },
  methods: {
    ...mapActions("admin_organizations", ["getList"]),
    ...mapActions("admin_user", ['updateUserAdmin']),
    onCloseModal() {
      this.userDetail = _.cloneDeep(this.propUserDetail);
      this.$emit("close");
      return true;
    },
    async getListMenu() {
      await EngineApi.getMenu().then((res) => {
        this.dataMenu = res.data
        this.user.menu_ids = this.getEngineIdsInit(res.data)
      })
    },
    async initData() {
      // this.user = { ...this.userState };
      await this.getListMenu()
      this.user.id = this.userState.id
      this.user.full_name = this.userState.full_name
      this.user.email = this.userState.email
      this.user.password = this.userState.password
      this.changeEngineIds(this.userState.menu_list)
      this.user.org_id = this.userState.org_id ? this.userState.org_id : this.orgId
      this.errorMessages = null;
    },
    async onSubmit() {
      if (this.isLoading) return false;
      this.errorMessages = null;
      this.$refs.editForm.validate(async (isValid) => {
        if (!isValid) return false;
        let menuList = [];
        this.user.menu_ids.forEach((item) => {
          if (item.checked) {
            menuList.push({id: item.id, action: item.action})
          }
        })
        this.isLoading = true;
        let res = await this.updateUserAdmin({...this.user, menu_list: menuList, menu_ids: []});
        this.isLoading = false;
        if (!res.success) {
          if (res.data) this.errorMessages = res.data;
          return false;
        }
        this.$emit("onUserUpdated");
      });
    },
    getEngineIds(data) {
      const arr = []
      for (const item of data) {
        if (item.id) {
          arr.push(item.id)
        }
      }
      return arr
    },
    getEngineIdsInit(data) {
      const arr = []
      for (const item of data) {
        if (item.id) {
          arr.push({
            id: item.id,
            checked: false,
            action: READ,
            title: item.title
          })
        }
      }
      return arr
    },
    changeEngineIds(data) {
      data.forEach((item) => {
        const obj = this.user.menu_ids.find((value) => value.id === item.id);
        if (obj) {
          obj.action = item.action
          obj.checked = true;
        }
      })
    },
    handleChange(index) {
      console.log(this.user.menu_ids[index])
      this.user.menu_ids[index].action = READ
    }
  },
  watch: {
    isOpenEditModal(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.initData();
    },
    propUserDetail(newVal) {
      this.userDetail = _.cloneDeep(newVal);
    },
  },
};
</script>
<style scoped>
/deep/.el-form-item__label {
  line-height: normal;
}

/deep/.menu-list > .el-form-item__content > .item-data > .el-checkbox {
  width: 100%;
}
</style>
